import React, { Component } from "react";
import { I18n } from 'aws-amplify';
import {
    Row,
    Col,
    Form,
    Icon,
    Spin,
    Input,
    Select,
    Button
} from 'antd';

import styled from 'styled-components';

const { Option } = Select;

const BoxSpin = styled.div`
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px 0;
`

const FormBox = styled(Form)`

`

class FilterDashAdminA extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {

                this.props.action(values);
            }
        });
    };
    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
        const { filters } = this.props

        if (!filters) {
            return (
                <BoxSpin>
                    <Spin />
                </BoxSpin>
            )
        }


        return (
            <FormBox onSubmit={this.handleSubmit}>
                <Row gutter={6}>
                    <Col sm={6}>
                        <Form.Item
                            label={I18n.get("Pais")}>
                            {getFieldDecorator('country', {
                                rules: [{ required: false, message: 'ops!' }],
                                initialValue: "BRA"
                            })(
                                <Select
                                    style={{ width: "100%" }}
                                    showSearch={true}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }

                                >
                                    {filters && filters.country.map((item, index) => {
                                        return <Option className="" disabled={!item.enabled} value={item.code} key={index}>{item.label}</Option>
                                    })}

                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col sm={2}>
                        <Form.Item className="labelClean" label="&nbsp;">
                            <Button
                                className="button bt-bpool black"
                                shape="round"
                                htmlType="submit"
                                disabled={!filters}
                                loading={this.props.task && this.props.task.busy}
                            >
                                OK
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </FormBox>
        )
    }
}



const FormFilterDashAdminA = Form.create({})(FilterDashAdminA);

export default FormFilterDashAdminA;

